// Initialization service to set up the database and run migrations
import databaseService from './databaseService';
import migrationService from './migrationService';

class InitService {
  constructor() {
    this.initialized = false;
  }

  async initialize() {
    if (this.initialized) {
      console.log('Blog system already initialized');
      return;
    }

    try {
      console.log('Initializing blog system...');
      
      // Try to initialize database with better error handling
      try {
        await databaseService.init();
        console.log('Database initialized successfully');
        this.databaseAvailable = true;
      } catch (error) {
        console.warn('Database initialization failed, using fallback mode:', error.message);
        this.databaseAvailable = false;
      }
      
      this.initialized = true;
      console.log('Blog system initialized successfully');
      
    } catch (error) {
      console.error('Failed to initialize blog system:', error);
      // Always mark as initialized to prevent infinite loops
      this.initialized = true;
      this.databaseAvailable = false;
    }
  }

  async runMigrationsInBackground() {
    try {
      // Check if we need to run migration
      let posts = [];
      let archives = [];
      
      try {
        posts = await databaseService.getAllPosts();
        archives = await databaseService.getAllArchives();
      } catch (error) {
        console.warn('Error loading existing data:', error);
        return;
      }
      
      if (posts.length === 0) {
        console.log('No posts found, running migration...');
        try {
          await migrationService.migrateAllJSONFiles();
        } catch (error) {
          console.warn('Migration failed:', error);
        }
      }

      if (archives.length === 0) {
        console.log('No archives found, creating sample archives...');
        try {
          await migrationService.createSampleArchivePosts();
        } catch (error) {
          console.warn('Failed to create sample archives:', error);
        }
      }
    } catch (error) {
      console.warn('Background migration failed:', error);
    }
  }

  async isInitialized() {
    return this.initialized;
  }

  isDatabaseAvailable() {
    return this.databaseAvailable === true;
  }

  async resetDatabase() {
    try {
      console.log('Resetting database...');
      // Close existing connection
      if (databaseService.db) {
        databaseService.db.close();
        databaseService.db = null;
      }
      
      // Delete the database
      const deleteRequest = indexedDB.deleteDatabase(databaseService.dbName);
      await new Promise((resolve, reject) => {
        deleteRequest.onsuccess = () => {
          console.log('Database deleted successfully');
          resolve();
        };
        deleteRequest.onerror = () => {
          console.error('Failed to delete database:', deleteRequest.error);
          reject(deleteRequest.error);
        };
        deleteRequest.onblocked = () => {
          console.warn('Database deletion blocked, please close other tabs');
          resolve(); // Continue anyway
        };
      });
      
      // Reset initialization flag
      this.initialized = false;
      console.log('Database reset complete - refresh the page to reinitialize');
    } catch (error) {
      console.error('Failed to reset database:', error);
    }
  }
}

// Create a singleton instance
const initService = new InitService();

export default initService;
